import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownTimerProps = {
  tone?: 'light' | 'dark';
};
export function CountdownTimer({
  tone = 'light'
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const box = tone === 'dark' ? 'bg-white/10 text-white' : 'bg-ink text-white';
  const label = tone === 'dark' ? 'text-white/60' : 'text-white/60';
  const units = [{
    value: hours,
    name: 'Horas'
  }, {
    value: minutes,
    name: 'Min'
  }, {
    value: seconds,
    name: 'Seg'
  }];
  return <div className="flex items-center gap-3" role="timer" aria-live="off" data-id="element-87" data-mp="1faiut6pcqdi6">
      {units.map(unit => <div key={unit.name} className={`flex min-w-[4.5rem] flex-col items-center rounded-lg px-3 py-3 ${box}`} data-id="element-88" data-mp="1aetqyr6auag2">
          <span className="display text-3xl tabular-nums sm:text-4xl" data-id="element-89" data-mp="34r0bwhozw5lk">
            {unit.value}
          </span>
          <span className={`mt-1 text-[10px] font-bold uppercase tracking-[0.2em] ${label}`} data-id="element-90" data-mp="2zsqhi9b3h910">
            {unit.name}
          </span>
        </div>)}
    </div>;
}